/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-04-24 18:01:21
* @Last Modified by:   lokialone
* @Last Modified time: 2017-05-19 17:34:42
*/

'use strict';

import {
    // SYNC_LOCAL_RECORDS_ERROR,
    ET_QUIS_PROIDENT_DOLORE
} from '../const/const-api-error-code.js';

/**
 * 获取错误信息
 *     推荐在 _instance 中统一处理
 */

export function getDataWrapperFromRes(res) {
    return res.data;
}

export function getDataAndErrorFromDataWrapper(dataWrapper) {
    if (dataWrapper.success) {
        return dataWrapper.data;
    } else {
        return Promise.reject(dataWrapper);
    }
}

/**
 * 处理错误信息
 *     推荐在 /api 中统一处理
 */
export function _dealByCondition(err, callback) {
    if (err instanceof Error) {
        return Promise.reject(err);
    }
    if (err._dealt) {
        return Promise.reject(err);
    }
    callback(Object.assign({}, err), err);
    err._dealt = true;
    return Promise.reject(err);
}

export function example(err) {
    return _dealByCondition(err, function (_err) {
        if (_err.code === ET_QUIS_PROIDENT_DOLORE) {
            // /
        }
    });
}



// WEBPACK FOOTER //
// ./src/api/_error.js